import { useLayoutEffect } from 'react';

import { addRule } from '@/utils/panel-revert-tracker';

/**
 * Restores `panelOpen` to its pre-entry value when leaving a route region.
 * Pair with `useSetLayout` so panel overrides don't leak across routes.
 *
 * - `matcher` is substring-tested against `location.pathname`; sub-paths stay in-region.
 * - Snapshot is captured at region entry, before `useSetLayout` mutates state. Manual toggles inside the region are ignored.
 * - Order-independent vs `useSetLayout`; registration is idempotent and session-persistent.
 * - Requires `usePanelRevertTracker` at the app root (already wired in `App.tsx`).
 *
 * @example
 * useRevertPanelOnPathExit('/settings'); // panel returns to its pre-/settings state on exit
 * useSetLayout({ panelOpen: true, ... });
 */
const useRevertPanelOnPathExit = (matcher: string) => {
  useLayoutEffect(() => {
    addRule(matcher);
  }, [matcher]);
};

export default useRevertPanelOnPathExit;
